import NewsArticleContentContainer from "./NewsArticleContentContainer";
import NewsArticleContentStore from "./NewsArticleContentStore";

export default NewsArticleContentStore(NewsArticleContentContainer);